import { IconBrandWhatsapp, IconPhone } from '@tabler/icons-react';
import { ActionIcon, Container, Group } from '@mantine/core';
import logo from './../../imgs/logo.png';

import classes from './Footer.module.css';

export function Footer() {
  return (
    <footer className={classes.footer}>
      <Container className={classes.inner}>
        <img src={logo} alt="Logo" className={classes.logo} />
        <Group gap={0} className={classes.links} justify="flex-end" wrap="nowrap">
          <ActionIcon
            role="link"
            aria-label="Contáctanos por WhatsApp"
            size="lg"
            color="gray"
            variant="subtle"
            component="a"
            href="https://wa.me/8138924955"
          >
            <IconBrandWhatsapp size={18} stroke={1.5} />
          </ActionIcon>
          <ActionIcon size="lg" color="gray" variant="subtle" component="a" href="tel:8138924955" aria-label="Llamar" role="link">
            <IconPhone size={18} stroke={1.5} />
          </ActionIcon>
          <ActionIcon size="lg" color="gray" variant="subtle" component="a" href="tel:9845559929" aria-label="Llamar" role="link">
            <IconPhone size={18} stroke={1.5} />
          </ActionIcon>
        </Group>
      </Container>
    </footer>
  );
}
